

















































import { Component, Emit, Vue, Watch } from "vue-property-decorator";
import { Action, Getter, namespace, State } from "vuex-class";

import { Evidence, Match, Token } from "@/types";
import BaseToken from "@/components/BaseToken.vue";
import BaseTab from "@/components/BaseTab.vue";
import EvidencedDocument from "@/components/EvidencedDocument.vue";
import MatchedDocument from "@/components/MatchedDocument.vue";
import NavigablePane from "@/components/NavigablePane.vue";
import { isOutOfView, range } from "@/utils";
import DocumentForm from "@/components/DocumentForm.vue";
import CodeForm from "@/components/CodeForm.vue";
import DocumentSummary from "@/components/DocumentSummary.vue";

const Details = namespace("details");

const Evidences = namespace("evidences");

@Component({
  components: {
    DocumentSummary,
    DocumentForm,
    CodeForm,
    NavigablePane,
    MatchedDocument,
    EvidencedDocument,
    BaseToken,
    BaseTab
  }
})
export default class SinglePaneDocument extends Vue {
  private type: string = "1";

  private types: [string, string, any?][] = [
    ["1", "Conditions & Symptoms"],
    ["7", "Procedures"],
    ["4", "Labs & Vitals"],
    ["6", "Medications"],
    ["15", "Misc", { width: "max-content", flexShrink: "0" }]
  ];

  private clusteredEvidences: any[][] = [];

  private clusteredRemainingMatches: any[][] = [];

  private container: HTMLElement | null = null;

  @State("text")
  private document!: string;

  @State("tokens")
  private tokens!: Token[];

  @State("blocks")
  private blocks!: number[][];

  @Details.State("evidence")
  private evidence!: Evidence | null;

  @Evidences.Getter("parsed")
  private evidences!: Evidence[][];

  @Action("details/update")
  show!: (value: Evidence) => void;

  @Getter("matches/parsed")
  private indexed!: (type: string) => (Match[] | null)[];

  @Getter("matches/flatten")
  private flatten!: Match[];

  select(matches: Match[]) {
    this.$emit("select", matches[0]);
  }

  get matches(): (Match[] | null)[] {
    return this.indexed("1");
  }

  get remainingMatches() {
    return this.matches.map((cluster: Match[] | null, index: number) => {
      if (
        !cluster ||
        cluster.length === 0 ||
        cluster[0].context["assertion"] !== "posited" ||
        cluster[0].context["subject"] !== "patient" ||
        cluster[0].context["allergy"] === "true" ||
        this.evidences[index].length > 0 ||
        range(...cluster[0].concept.text.tokpos).filter(
          (j: number) => this.evidences[j].length > 0
        ).length > 0
      )
        return null;

      return cluster;
    });
  }

  @Watch("evidence")
  scrollTo() {
    if (this.evidences) {
      this.$nextTick(() => {
        if (this.evidence) {
          this.type = "evidence";

          const evidences = [
            ...this.$el.querySelectorAll(
              `span[data-codes*="${this.evidence.id},"]`
            )
          ] as HTMLElement[];
          const container = this.$refs["container"] as HTMLElement;

          if (
            evidences &&
            evidences.length > 0 &&
            evidences.every(evidence => isOutOfView(container, evidence))
          ) {
            container.scrollTop = evidences[0].offsetTop - 100;
          }
        }
      });
    }
  }
}
